<template>
  <!-- 客户信息插件 -->
  <div>
    <div class="ddcheckitem">
      <van-collapse v-model="activeNames" @change="onChangeColl">
        <van-collapse-item value="购买须知" name="1">
          <template #title>
            <div class="activeNamestitle">
              <div>零售价：<span>￥{{ priceRetail || '暂无' }}</span></div>
            </div>
          </template>
          <div class="goods-cont-li">
            <div v-html="gmxzItem"></div>
          </div>
        </van-collapse-item>
      </van-collapse>
      <div class="date" v-if="istraveldate" @click="initDate">
        <div class="label">出行日期：</div>
        <div class="date-time">{{ traveldate }}</div>
      </div>
      <div class="ddxznum">
        <div class="ddnum">
          <div>库存：{{ typeof stock === 'number' ? (stock <= 0 ? '库存不足' : stock > 10 ? '库存充足' : '库存紧张') : stock }}</div>
          <div class="leftnum">选择数量</div>
          <van-stepper v-model="yknum" :disable-input="isstepperInput" input-width="40px"
            :disabled="treelist.price && treelist.stock ? false : true" button-size="32px" @plus="addYk(true)"
            @minus="addYk(false)" @change="onChangeNum" min="0" max="999" />
        </div>
      </div>
      <div class="yklist" v-if="yknum > 0">
        <div class="ykitem" v-for="(item, index) in ykListData" :key="index">
          <div class="left">
            <div class="cleryk" v-if="item.contacts == ''">
              <span>游客{{ index + 1 }}</span>
            </div>
            <div class="cleryk" v-else @click="cutYk(index)">
              <span>游客{{ index + 1 }}</span>
              <van-icon name="delete-o" />
            </div>
            <div class="ykxx" @click="openYkpopup(item, index)">
              <span v-if="item.contacts == ''">点击补全客户信息</span>
              <div v-else>
                <div class="xxitem">{{ item.contacts }} {{ item.telephone }}</div>
                <!-- <div class="xxitem">手机号 {{item.telephone}}</div>
                <div class="xxitem">证件类型 {{item.card_type || '--'}}</div>
                <div class="xxitem">证件号 {{item.IDCard}}</div> -->
              </div>
            </div>
          </div>
          <div class="right" @click="openYkpopup1(index)">
            <span>选择</span>
          </div>
        </div>
      </div>
      <div class="date van-hairline--top-bottom coupon-div" v-if="yknum > 0" @click="couponClick">
        <div class="label">
          <!--优惠券：-->
        </div>
        <div class="date-time couponShowText" v-if="couponActive">
          <div class="couponContent">
            <div class="discountnumber">{{ couponActive.name }}*{{ number }}</div>
            <div class="discountprice">已优惠：{{ couponActive.price }}元</div>
          </div>
        </div>
        <div class="check-coupon" v-else>选择优惠券</div>
      </div>
      <div v-if="yknum > 0">
        <div class="content-main" style="margin-top: 15px;" v-if="category_group_id == 5">
          <div class="title-top-ells2">乘客添加</div>
          <div class="main">
            <leoAddINsure @selectTime="selectTime" :columns="columns"></leoAddINsure>
          </div>
        </div>
      </div>
    </div>
    <!--日历组件-->
    <div v-if="showtime">
      <van-calendar v-model="showtime" color="#ffaa00" type="single" style="margin-bottom: 0;"
        :style="{ height: '65%' }" :show-confirm="false" @confirm="onConfirmdate" :min-date="minDate"
        :max-date="maxDate">
      </van-calendar>
    </div>
    <!--新增或者编辑-->
    <van-popup v-model="ykpopupshow" style="margin-bottom: 0;" round position="bottom" :style="{ height: '60%' }">
      <div class="popup-box">
        <div class="titile">
          <span class="an"></span>
          <span>{{ titlename }}</span>
          <span class="an" @click="closePopup">取消</span>
        </div>
        <van-form @submit="addYkxx">
          <van-field v-model="ykxx.namenew" clearable name="姓名" label="姓名" placeholder="必填,输入证件上的姓名" />
          <van-field v-model="ykxx.telnew" clearable label="手机号" type="tel" placeholder="必填,输入联系人手机号" />
          <van-field readonly label="证件类型" :value="ykxx.card_type" placeholder="请选择证件类型" @click="showPicker = true" />
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker title="证件类型" show-toolbar :columns="columns" @cancel="showPicker = false"
              @confirm="onConfirm" />
          </van-popup>
          <van-field v-model="ykxx.idcardnew" clearable label="证件号"
            :placeholder="cardMust ? '必填,输入联系人证件号' : '非必填,输入联系人证件号'" />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">提交</van-button>
          </div>
        </van-form>
        <div class="items">
          <div class="item">
            <span>温馨提示：请您填写出行人真实准确的信息，如存在实名制要求的，还需要您再出游时出具相应证件用于身份验证。</span>
          </div>
        </div>
      </div>
    </van-popup>
    <!--已有游客列表-->
    <van-popup v-model="ykpopupshow1" style="margin-bottom: 0;" round position="bottom"
      :style="{ height: '80%', width: '100%' }">
      <div class="popup-box" style="height:calc(100% - 25px) ; overflow: hidden;">
        <div class="titile">
          <span class="an" @click="addUser">新增</span>
          <span>选择游客</span>
          <span class="an" @click="closePopup1">取消</span>
        </div>
        <div class="gdp-m">
          <div v-if="userlist.length < 1" style="padding: 30px 0;text-align: center;color: #b6b6b6;">暂无游客信息</div>
          <van-cell v-else v-for="(item, index) in userlist" :key="index" :title="item.contacts + ' ' + item.telephone"
            :label="item.card_type_text + '  ' + item.IDCard" clickable @click="checkUser($event, item)">
            <template #right-icon>
              <div style="width: 80px;display: flex;align-items: center;justify-content: space-between;">
                <p style="width: 30px; display: flex;align-items: center;" @click="openYkpopup(item, -1)">
                  <van-icon name="edit" size="20" color="#00aaff" />
                </p>
                <p style="width: 30px; display: flex;align-items: center;" @click="deledteuser(item)">
                  <van-icon name="delete-o" size="20" color="#ff5500" />
                </p>
              </div>
            </template>
          </van-cell>
        </div>
      </div>
    </van-popup>
    <!-- 优惠券列表 -->
    <van-popup v-model="showCoupon" closeable close-icon="close" round position="bottom"
      style="height: 90%; padding-top: 4px;">
      <div class="van-coupon-list__list">
        <h5>选择优惠券</h5>
        <div v-if="coupons.length > 0">
          <div class="van-coupon" v-for="(item, index) in coupons" :key="index">
            <div class="van-coupon__content">
              <div class="van-coupon__head">
                <h2 class="van-coupon__amount">{{ item.reward_value }}<span>元</span></h2>
                <p class="van-coupon__condition">{{ item.type_text }}</p>
              </div>
              <div class="van-coupon__body">
                <p class="van-coupon__name">{{ item.reward_name }} x{{ item.unused }}</p>
                <p class="van-coupon__valid">{{ item.expire_time }} 过期</p>
                <!--              <p class="van-refer_to">{{item.refer_to}}</p>-->
                <div role="checkbox" class="van-checkbox van-coupon__corner" style="top: 24px;">
                  <van-checkbox v-model="item.checkedcoupon" icon-size="22px" @click="changecoupon(index)"
                    checked-color="#ee0a24"></van-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-empty v-else description="暂无可用优惠券" />
      </div>
      <van-overlay :show="showNumber" @click="showNumber = false">
        <div class="wrapper" @click.stop>
          <div class="block">
            <h3>输入使用数量</h3>
            <van-cell-group>
              <van-field v-model="number" type="digit" label="数量:" max="5" placeholder="请输入领取数量" @input="onInput" />
            </van-cell-group>
            <div class="footer">
              <van-button type="primary" size="small" @click="getCoupon" :loading="disabled">确定</van-button>
              <van-button type="default" size="small" @click="showNumber = false">取消</van-button>
            </div>
          </div>
        </div>
      </van-overlay>
    </van-popup>
  </div>
</template>

<script>
import * as util from "@/utils/network";
import {
  getFormatDate
} from "@/utils/date";
import leoAddINsure from "@/components/TP/leoAddINsure";
import {
  Toast,
} from "vant";
export default {
  components: {
    leoAddINsure,
  },
  props: {
    treelist: {
      type: Object,
      default: null
    },
    gmxzData: {
      type: String,
      default: ''
    },
    // 证件是否必须
    cardMust: {
      type: Number,
      default: 0
    },
    // 价格
    skulistprice: {
      type: String,
      default: ''
    },
    groupid: {
      type: String,
      default: '',
    },
    goods_id: {
      type: String,
      default: '',
    },
    // 当前操作的sku
    skuid: {
      type: String,
      default: '',
    },
    // 订单类型 一人多证..
    ordertype: {
      type: String,
      default: ''
    },
    // 证件类型
    columns: {
      type: Array,
    },
    // 库存
    stock: {
      type: Number,
      default: 0
    },
    // 零售
    priceRetail: {
      type: String,
      default: ''
    },
    deData: {
      type: Object,
      default: () => {
        return {
          defaultPrice: 0,
          defaultStock: 0,
          Dates: []
        }
      }
    },
    package: {
      type: String,
      default: ''
    },
    package_name: {
      type: String,
      default: ''
    },
    category_group_id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeNames: [],
      yknum: 0, // 当前商品数量
      ykListData: [], // 选中的游客信息集合
      selectid: -1, // 当前选中的游客下标
      gmxzItem: null, // 购买须知 --父组件传值获取
      titlename: "新增游客",
      ykxx: { // 新增的游客信息
        namenew: "",
        telnew: "",
        idcardnew: "",
        card_type: ""
      },
      ykxxS: {}, // 当前选中的游客
      selectnum: 0, //已填写数量
      ykpopupshow: false, // 新增或者编辑游客 弹出
      ykpopupshow1: false, // 选择游客 弹出
      order_type: '', // 默认一证多码
      userlist: [], // 游客列表
      isTc: false, //新增-false还是编辑-true
      totalPrice: 0, // 计算价格
      showPicker: false, // 显示证件类型下拉框
      isstepper: false, // 数量是否可点击
      isstepperInput: false, // 计步器输入框是否可点击
      istraveldate: false,
      traveldate: '请选择出行日期',
      showtime: false,
      minDate: null,
      maxDate: null,
      couponActive: null,
      showCoupon: false, // 优惠券列表
      chosenCoupon: -1,
      coupons: [],
      role: '20', // 10个人 20 分销商
      showNumber: false,
      number: 1,
      maxlength: 1, // 最大领取数 为点击的对象下的number
      checkedcoupon: false,
      disabled: false,
      newprice: null,
      skuidprice: null,
      genericUsedNumber: 0,
      goodsUsedNumber: 0,
      checkCoupons: [],
    };
  },
  created() { },
  mounted() {
    this.defuaultListNum();
    this.order_type = this.ordertype;
    this.switchType(this.ordertype);
    let packageaa = this.package;
    let package_name = this.package_name;
    if (packageaa && package_name) {
      this.istraveldate = true
    }
    //this.istraveldate = true
  },
  watch: {
    ordertype(newValue, oldValue) {
      if (newValue) {
        this.order_type = newValue
        this.defuaultListNum();
        this.switchType(newValue)
      }
    },
  },
  methods: {
    // 获取参保人信息
    selectTime(data) {
      console.log(this.skuid)
      console.log(data)
      let newarray = [];
      data.forEach((item, index) => {
        let {
          contacts,
          telephone,
          birthday,
          IDCard,
          card_type
        } = item;
        let isall = contacts && telephone && IDCard && card_type && birthday;
        if (isall) {
          let obj = {
            'spec_sku_id': this.skuid,
            'goods_attr': this.treelist.item_name,
            contacts,
            telephone,
            card_type: this.visitorAndPriceVal(card_type, 'text'),
            card_no: IDCard,
            birthday
          }
          newarray.push(obj);
        }
      })
      console.log(newarray)
      let key = this.skuid;
      let query = {
        key,
        value: newarray
      };
      console.log(query)
      this.$emit('selectTimeClick', query)
    },
    // 切换类型
    switchType(value) {
      if (value == '10' || value == '30') {
        this.isstepperInput = true
      } else {
        this.isstepperInput = false
      }
    },
    //切换购买须知面板时触发
    onChangeColl() {
      this.gmxzItem = this.gmxzData;
    },
    /***********************游客列表********************************* */
    // 初始化游客数量
    defuaultListNum() {
      let that = this;
      let ny = that.yknum;
      if (that.order_type == "20") {
        ny = 1;
      }
      that.ykListData = [];
      for (var i = 1; i <= ny; i++) {
        let item = {
          contacts: "",
          telephone: "",
          card_type: "",
          IDCard: ""
        };
        that.ykListData.unshift(item);
      }
    },
    // 删除游客
    deledteuser(item) {
      var url = "/addons/litestore/api.player/del";
      let that = this;
      //这里直接调用网络接口
      util.post(
        url, {
        id: item.id
      },
        function () {
          that.getUserList(); // 刷新列表
        }
      );
    },
    //新增游客
    addUser() {
      this.ykpopupshow = true;
      this.isTc = false;
      this.titlename = "新增游客";
      this.ykxx = { // 新增游客信息
        namenew: "",
        telnew: "",
        idcardnew: "",
        card_type: "",
      };
    },
    // 打开添加游客信息
    openYkpopup(item, i) {
      this.selectid = i;
      let that = this;
      let tt = item;
      let isedit = true;
      if (!tt.contacts && !tt.telephone) {
        isedit = false
      }
      // 编辑的情况下再去赋值
      if (isedit) {
        that.titlename = "编辑游客";
        that.ykxxS = tt;
        that.ykxx.namenew = tt.contacts;
        that.ykxx.telnew = tt.telephone;
        that.ykxx.idcardnew = tt.IDCard;
        that.ykxx.card_type = that.visitorAndPriceVal(tt.card_type, 'val');
        that.isTc = true;
        if (!tt.id) {
          that.userlist.forEach(list => {
            let isedit = list.IDCard == tt.IDCard && list.telephone == tt.telephone && list.contacts == tt
              .contacts;
            if (isedit) {
              that.ykxxS = list;
            }
          })
        }
      } else {
        that.titlename = "新增游客";
        that.isTc = false;
        this.ykxx = { // 新增游客信息
          namenew: "",
          telnew: "",
          idcardnew: "",
          card_type: "",
        };
      }
      that.ykpopupshow = true;
    },
    // 外部删除游客
    cutYk(i) {
      let that = this;
      let item = {
        contacts: "",
        telephone: "",
        IDCard: "",
        card_type: ""
      };
      that.ykListData.splice(i, 1, item);
    },
    // 点击补全客户信息
    openYkpopup1(i) {
      this.ykpopupshow1 = true;
      this.selectid = i;
      this.getUserList();
    },
    // 请求获取游客列表
    getUserList() {
      var url = "/addons/litestore/api.player/index";
      let that = this;
      //这里直接调用网络接口
      util.post(url, {}, function (result) {
        that.userlist = result.data.list;
      });
    },
    //游客列表中选择游客
    checkUser(e, item) {
      // 阻止点击编辑和删除
      if (
        e.target._prevClass == "van-icon van-icon-edit" ||
        e.target._prevClass == "van-icon van-icon-delete-o"
      ) {
        return;
      }
      let that = this;
      that.ykxxS = item; // 当前选中的游客
      let idata = { // 提取所需的数据
        contacts: item.contacts,
        telephone: item.telephone,
        IDCard: item.IDCard,
        card_type: that.visitorAndPriceVal(item.card_type, 'val'),
        skuid: that.skuid
      };
      that.ykListData.splice(that.selectid, 1, idata); // 替换到指定下标
      this.$emit("YkSubmit", that.ykListData, that.skuid);
      that.ykpopupshow1 = false;
      that.isTc = false;
    },
    // 添加/编辑客户信息
    addYkxx() {
      let that = this;
      let msg = "";
      if (that.ykxx.namenew == "") {
        msg = "请填写姓名";
      } else if (that.ykxx.telnew == "") {
        msg = "请填写手机号";
      } else if (that.cardMust && !that.ykxx.card_type) {
        msg = "请选择证件类型";
      } else if (that.cardMust && that.ykxx.idcardnew == "") {
        msg = "请填写证件号";
      }
      if (msg != "") {
        Toast({
          message: msg
        });
        return;
      } else {
        let idata = {
          contacts: that.ykxx.namenew,
          telephone: that.ykxx.telnew,
          IDCard: that.ykxx.idcardnew,
          card_type: that.ykxx.card_type,
          skuid: that.skuid
        };
        that.ykxxS.contacts = that.ykxx.namenew;
        that.ykxxS.telephone = that.ykxx.telnew;
        that.ykxxS.IDCard = that.ykxx.idcardnew;
        that.ykxxS.card_type = that.visitorAndPriceVal(that.ykxx.card_type, 'text');
        that.openYkE(that.ykxxS, idata); // 编辑还是新增游客

      }
    },
    visitorAndPriceVal(val, type) {
      let columns = this.columns;
      console.log(columns, 'columns')
      let value = val + '';
      columns.forEach(item => {
        if (type == 'text') {
          if (item.text == value) {
            val = item.value;
          }
        }
        if (type == 'val') {
          if (item.value == value) {
            val = item.text;
          }
        }
      })
      return val
    },
    //编辑-新增游客-发送请求
    async openYkE(item, idata) {
      let that = this;
      var url = "/addons/litestore/api.player/add";
      if (that.isTc) { //编辑
        url = "/addons/litestore/api.player/edit";
      }
      let res = await util.post(url, item);
      if (res) {
        if (res.code == 1) { // 新增或者编辑成功
          that.getUserList(); // 刷新游客列表
          that.ykListData.splice(that.selectid, 1, idata);
          this.$emit("YkSubmit", that.ykListData, that.skuid);
        } else {
          // 置空对应的游客信息
          let dataaa = {
            contacts: "",
            telephone: "",
            card_type: '',
            IDCard: "",
            skuid: that.skuid
          }
          that.ykListData.splice(that.selectid, 1, dataaa);
        }
        //清空当前弹出框内容
        that.ykxxS = {};
        that.ykxx = {
          namenew: "",
          telnew: "",
          idcardnew: "",
          card_type: "",
        };
        that.ykpopupshow = false;
      }
    },
    // 计数器数量改变时触发
    onChangeNum(v) {
      if (!this.skulistprice) {
        return false
      }
      //let skulistprice = parseFloat(this.skulistprice);
      let skulistprice = this.skulistprice;
      let obj = {
        num: v,
        id: this.skuid,
        skulistprice,
        groupid: this.groupid,
        price: this.skuidprice ? this.skuidprice[this.skuid] : null
      }
      this.newprice = obj;
      this.$emit("onChangeNum", obj);
    },
    // 点击计数器时触发
    addYk(isadd) {
      if (!this.skulistprice) {
        return false
      }
      let that = this;
      // 一人多证时
      if (that.order_type == "20") {
        if (this.yknum > 0) {
          return;
        } else {
          that.ykListData = [];
        }
      }

      if (isadd) {
        this.yknum = ++this.yknum;
      } else {
        this.yknum = --this.yknum;
      }
      if (isadd) {
        let item = {
          contacts: "",
          telephone: "",
          card_type: '',
          IDCard: "",
          skuid: that.skuid
        };
        that.ykListData.unshift(item); // 增加一个游客
      } else {
        that.ykListData.splice(0, 1); // 删除一个游客
      }
      this.$emit("YkSubmit", that.ykListData, that.skuid);
    },
    // 编辑-添加弹出
    closePopup() {
      this.ykpopupshow = false;
    },
    // 游客弹出
    closePopup1() {
      //this.isTc = false;
      this.ykpopupshow1 = false;
    },
    /***证件类型 */
    onConfirm(value, index) {
      this.showPicker = false;
      this.ykxx.card_type = value.text
    },
    /***选择日期 */
    // 日历弹出框选中
    onConfirmdate(date) {
      let dqdate = this.formatDate(date); // 返回日期格式
      this.traveldate = getFormatDate(dqdate, 'yyyy-mm-dd');
      let obj = {
        skuid: this.skuid,
        date: this.traveldate,
        package: this.package
      }
      this.showtime = false;
      this.$emit('travelDate', obj)
    },
    // 日期格式
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    // 当前日期后三天，和三个月后的最后一天日期
    getThreeMonthsLaterDates() {
      // 获取当前日期
      let currentDate = new Date();
      // 计算三个月后的日期
      let threeMonthsLaterDate = new Date(currentDate);
      threeMonthsLaterDate.setMonth(currentDate.getMonth() + 3);
      // 构造包含前三天日期和三个月后的日期的数组
      let combinedDates = [];
      // 添加当前日期开始的前三天日期
      for (let i = 0; i < 3; i++) {
        let previousDate = new Date(currentDate);
        previousDate.setDate(currentDate.getDate() + i);
        const formattedDate = this.formatDate(previousDate, 'y/m/d');
        combinedDates.push({
          year: previousDate.getFullYear(),
          month: previousDate.getMonth() + 1,
          day: previousDate.getDate(),
          date: formattedDate
        });
      }
      // 添加三个月后的日期
      const formattedDate = this.formatDate(threeMonthsLaterDate, 'y/m/d');
      combinedDates.push({
        year: threeMonthsLaterDate.getFullYear(),
        month: threeMonthsLaterDate.getMonth() + 1,
        day: threeMonthsLaterDate.getDate(),
        date: formattedDate
      });
      return combinedDates;
    },
    //初始化日历
    initDate() {
      let minMax = this.getThreeMonthsLaterDates();
      let last = minMax[minMax.length - 1];
      this.minDate = new Date();
      this.maxDate = new Date(last.date);
      this.showtime = true;
    },
    // 点击领取优惠券
    couponClick() {
      let yknum = this.yknum;
      if (yknum == 0) {
        return this.$toast('请先选择数量');
      }

      //处理已经选择的券
      console.log('checkedcoupon', this.checkedcoupon)

      let params = {
        goods_id: this.goods_id,
        spec_sku_id: this.skuid,
        generic_used: this.genericUsedNumber,
        goods_used: this.goodsUsedNumber,
        quantity: yknum,
        role: '20'
      }
      //console.log(params, 'params')
      let url = '/addons/litestore/api.coupon/goodsCouponList'; //'/addons/litestore/api.coupon/goodsCouponList';
      util.get(url, params, (res) => {
        res.data.coupons.forEach(x => {
          //x.max = x.number;
          x.checkedcoupon = false
        })
        this.showCoupon = true;
        this.coupons = res.data.coupons;
      });
    },
    //优惠券选中
    changecoupon(index) {
      //console.log(index)
      this.coupons.forEach(x => {
        x.checkedcoupon = false
      })
      let data = this.coupons[index];
      data.checkedcoupon = true
      if (!data.checkedcoupon) return false
      this.chosenCoupon = index;
      if (this.role == '20') {
        this.showNumber = true;
        this.number = data.unused > this.yknum ? this.yknum : this.unused;
      }

      //保存选中的优惠券
      //this.checkedcoupon[this.skuid] = [data.condition, this.number]

    },
    //数量处理
    onInput(value) {
      //
      this.number = value > this.yknum ? this.yknum : value;
      //console.log('value',value);

    },
    // 输入数量确认
    getCoupon() {
      if (this.number > this.yknum) {
        this.$toast("使用数量不能大于游客数量");
        return;
      }
      if (this.number < this.yknum) {
        this.$toast("优惠券使用数量必须等于游客数量");
        this.number = this.yknum;
        return;
      }

      if (this.number < 1) {
        this.$toast("使用数量不能小于1");
        return;
      }
      if (this.number > 1000) {
        this.$toast("无效的使用数量");
        return;
      }
      let index = this.chosenCoupon;
      let data = this.coupons[index];
      data.newnumber = this.number;
      // console.log(data)
      // 重组id和数量 拼接到订单中
      let price = Number(data.reward_value) * this.number;
      let obj = {
        id: data.id,
        number: this.number,
        skuid: this.skuid,
        price,
      }
      this.showNumber = false;
      this.showCoupon = false;
      this.skuidprice = {}
      this.skuidprice[this.skuid] = price
      this.couponActive = {
        name: data.reward_name,
        price
      };
      this.$emit('couponData', obj);
      this.newprice.price = price
      this.$emit("onChangeNum", this.newprice);
    },
    // 关闭弹出层
    // closePopup() {
    //   this.showNumber = false;
    //   this.showCoupon = false;
    // },
    // 选择时间
    // onConfirm(date) {
    //   const [start, end] = date;
    //   this.showtime = false;
    //   let obj = {
    //     start,
    //     end
    //   }
    //   this.$emit("onChangeTime", obj);
    //   this.$emit("onChangeNum", obj);
    // },
  }
};
</script>

<style lang="less">
/deep/ .van-popup--bottom {
  margin-bottom: 0 !important;
}

.popup-box {
  overflow-x: hidden;
  overflow-y: scroll;

  .van-cell {
    padding: 0 !important;
    line-height: 50px;
  }
}

.popup-box::-webkit-scrollbar {
  display: none;
}

.gdp-m {
  height: calc(100% - 52px);
  overflow-x: hidden;
}

.gdp-m::-webkit-scrollbar {
  display: none;
}

.ykusers {
  padding: 10px 0;
}

.ykusers+.ykusers {
  border-top: 1px solid #e5e5e5;
}
</style>

<style lang="less" scoped>
// 弹出框
.popup-box {
  padding: 15px;

  .titile {
    padding: 5px 0;
    display: flex;
    justify-content: space-between;

    span {
      display: block;
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
    }

    .an {
      color: #00aaff;
      font-size: 15px;
    }
  }

  .items {
    padding: 15px 0;

    .item {
      display: flex;
      padding: 12px 0;
      font-size: 14px;

      span {
        font-size: 12px;
        color: #959595;
      }
    }
  }
}

// 数量
.ddxznum {
  padding: 0 15px;
  background-color: #fff;

  .ddnum {
    padding: 10px 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

    .leftnum {
      font-size: 14px;
      font-size: #333;
      font-weight: 600;
    }
  }
}

// 游客选择
.yklist {
  .ykitem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding: 10px 15px;

    .left {
      display: flex;
      align-items: center;

      .cleryk {
        text-align: center;
        color: #909090;
        display: flex;
        align-items: center;

        span {
          margin-bottom: 0;
          display: block;
          margin-right: 8px;
        }
      }

      .ykxx {
        padding: 0 15px;

        span {
          color: #00aaff;
        }

        .xxitem {
          padding: 2px 0;
        }
      }
    }
  }

  .ykitem+.ykitem {
    border-top: 1px solid #dedede;
  }

  .right {
    font-size: 13px;
    color: #00aaff;
  }
}



.date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;

  .date-time {
    color: #909090;
  }
}
</style>
<style lang="less" scoped>
.van-coupon-list__list {
  h5 {
    font-size: 18px;
    margin-bottom: 25px;
    text-align: center;
  }

  .van-refer_to {
    font-size: 12px;
    width: 150px;
    color: #666;
    margin-top: 5px;
  }
}

/deep/ .van-popup__close-icon {
  z-index: 0;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 80%;
  padding: 15px;
  display: flex;
  align-items: center;
  flex-flow: column;
  background-color: #fff;

  h3 {
    margin-bottom: 15px;
  }

  .message {
    justify-content: flex-start;
    width: 100%;
    margin-top: 15px;
    font-size: 14px;
    color: #666;
  }

  .footer {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    button {
      width: 100px;
      margin-left: 15px;
    }
  }
}

.coupons-btn {
  border-radius: 4px;
}

.nocoupons {
  background: #dfdfdf;

  .coupons-btn {
    background: #999;
    border-color: #999;
  }
}

.coupon-div {
  color: red;

  .check-coupon {
    font-weight: bold
  }
}

.couponShowText {
  color: #ffa500;

  .couponContent {
    display: flex;
    align-items: center;

    .discountnumber {
      color: #666;
      margin-right: 20px;
    }

    .discountprice {
      color: red;
    }
  }
}

.content-main {
  .title-top-ells2 {
    font-weight: bold;
    padding-left: 15px;
  }
}
.ddcheckitem {
  .van-cell__title {
    .activeNamestitle {
      display: flex;
      .scribe {
        margin-left: 35px;
      }
    }
  }
  /deep/ .van-collapse-item .van-cell__value {
    flex: none;
  }
}
</style>
